import * as i0 from "@angular/core";
export class TooltipInfoTableAfsReviewService {
    constructor() {
        this.tooltipContent = `<div class="bl-tooltip__content">
  <h3 class="bl-tooltip__title">Sample:</h3>
  <ul class="bl-tooltip__list">
  <li class="bl-tooltip__item"><span class="bl-tooltip__text">Paramenter 1 / parameter 2</span></li>
  </ul>
  </div>`;
    }
    getTooltipContent() {
        return this.tooltipContent;
    }
}
TooltipInfoTableAfsReviewService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TooltipInfoTableAfsReviewService_Factory() { return new TooltipInfoTableAfsReviewService(); }, token: TooltipInfoTableAfsReviewService, providedIn: "root" });
